/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macro Calculator`)
};

const es_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Macros`)
};

const de_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makro-Rechner`)
};

const nl_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macro Calculator`)
};

const fr_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Macros`)
};

const it_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di macronutrienti`)
};

const pt_br2_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Macros`)
};

const pt_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Macros`)
};

const ja_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マクロ栄養素計算機`)
};

const zh_macro_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三大营养素计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_tool_name", locale)
	if (locale === "en") return en_macro_tool_name(inputs)
	if (locale === "es") return es_macro_tool_name(inputs)
	if (locale === "de") return de_macro_tool_name(inputs)
	if (locale === "nl") return nl_macro_tool_name(inputs)
	if (locale === "fr") return fr_macro_tool_name(inputs)
	if (locale === "it") return it_macro_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_macro_tool_name(inputs)
	if (locale === "pt") return pt_macro_tool_name(inputs)
	if (locale === "ja") return ja_macro_tool_name(inputs)
	return zh_macro_tool_name(inputs)
};